import React, {FC, useState} from 'react'
import {useNavigate} from 'react-router'
import {useUser} from 'entities/user'
import {SidebarMobile} from 'features/sidebar'
import {useHideForScroll} from 'shared/hooks/useHideForScroll'
import {mediaVariants} from 'shared/lib'
import {text} from 'shared/mirrors/text'
import {Avatar} from 'shared/ui/avatar'
import {Credits, Logo} from './img/icons'
import styles from './styles.module.scss'

type HeaderMobileProps = {
  wrapperRef?: React.RefObject<HTMLDivElement>
  mobilePaddingTop?: number
}

export const HeaderMobile: FC<HeaderMobileProps> = ({wrapperRef, mobilePaddingTop}) => {
  const {profile} = useUser()
  const navigate = useNavigate()
  const [isShowSidebarMobile, setIsShowSidebarMobile] = useState<boolean>(false)
  const isShowForScroll = useHideForScroll(wrapperRef || null, mobilePaddingTop)

  return (
    <>
      <div className={`${styles.header} ${!isShowForScroll ? styles.hide : ''}`}>
        <Avatar sx={{width: 34, height: 34}}
          src={profile.avatarUrl ? profile.avatarUrl + mediaVariants.square64 : ''}
          onClick={() => setIsShowSidebarMobile(!isShowSidebarMobile) }
        />

        <div className={styles.wrapperLogo} onClick={() => navigate('/people')}>
          <div className={styles.icon}><Logo /></div>
          <div className={styles.text}>{text.main.siteName}</div>
        </div>

        <div className={styles.credits} onClick={() => navigate('/credits')}>
          <div className={styles.icon}><Credits /></div>
        </div>
      </div>
      <SidebarMobile isActive={isShowSidebarMobile} onClose={() => setIsShowSidebarMobile(false)} />
    </>
  )
}
